<div class="tab-pane" role="tabpanel" id="Registro_bienes">
    <fieldset id="agregar_registro" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <div class="form-horizontal">
                            <div class="form-group">

                                <label for="inscrito" class="col-md-2 txt">Inscrito a Fojas</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Inscrito" id="inscrito" name="inscrito" formControlName="inscrito" (change)="add_registro()">
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>

                                <label for="fecha" class="col-md-2 txt">Numero</label>
                                <!-- form.controls?.busc_rut.hasError('invalidRut') -->
                                 
                                

                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="N&uacute;mero"  id="numero" name="numero" formControlName="numero" inputmode=”numeric” pattern="[0-9]*" (change)="add_registro()">
                                        <mat-error *ngIf="form.controls['numero'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="escritura" class="col-md-2 txt">Año</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Año" id="anio" name="anio" formControlName="anio" pattern="[0-9]*" (change)="add_registro()">
                                        <mat-error *ngIf="form.controls['anio'].hasError('pattern')">
                                            Solo se permiten caracteres <strong>numéricos</strong>
                                        </mat-error>  
                                        <mat-error *ngIf="!form.controls['anio'].hasError('pattern') && form.controls['anio'].hasError('min') || form.controls['anio'].hasError('max')">
                                            Debes ingresar un <strong>año</strong> correcto
                                        </mat-error> 
                                    </mat-form-field>
                                </div>
                                <div class="col-md-1"></div>
                                <label for="notario" class="col-md-2 txt">Registro de Bienes Raices de</label>
                                <div class="col-md-2">
                                    <mat-form-field class="example-full-width" style="width: 145px;">
                                        <input matInput placeholder="Bienes" id="bienes" name="bienes" formControlName="bienes" (change)="add_registro()">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>